import React from "react"
import { Box, BoxProps } from "@chakra-ui/core"
import { bp } from "../../utils/MediaQueries"

type PageContainerProps = BoxProps & {}

export default function PageContainer({ ...props }: PageContainerProps) {
  return <Box pt={bp(`2rem`, `4rem`)} {...props} minH="55vh" />
}
